<template>
  <div>
    <a-modal width="100%" :visible.sync="approvalFormVisible" :confirmLoading="confirmLoading" @cancel="handleCancel"
      okText="提交" wrapClassName="ant-modal-cust-warp" :dialog-style="{ height: '100%', top: 0 }">
      <template slot="title">
        <div class="modal-title">
          <span class="back-icon" @click="handleCancel"><a-icon type="left" />&nbsp;返回</span>
          <label>{{ modalTitle }}</label>
         
          <label style="display: flex; align-items: center">显示审批流程：
            <a-switch v-model="showApprovalProcess" />
          </label>
         
        </div>
      </template>
      <div class="work-name">
        <span class="work-name-label">工作名称/文号：</span>
        <a-input :addon-before="formName" v-model="submitForm.formTitle" placeholder="请填写工作名称/文号"
          :class="{ 'has-error': !submitForm.formTitle }">
          <template slot="addonAfter" v-if="formTitleRuleConfig.type === 1">
            <a-icon v-if="formTitleLoading" type="loading" />
            <a-icon v-else type="loading-3-quarters" />
          </template>
        </a-input>
      </div>
      <a-row :gutter="16" class="scrollable-content">
        <a-col :span="showApprovalProcess ? 16 : 24">
          <!-- <form-render :key="formRenderKey" ref="form" :forms="forms" v-model="formData" /> -->
        </a-col>
        <a-col v-if="showApprovalProcess" :span="8" class="sticky-content">
          <a-timeline v-if="process.length">
            <!-- 过滤条件分支 -->
            <a-timeline-item v-for="item in process.filter((v) => v.type !== 'CONDITIONS')" :key="item.id">
              <!-- 审批人 -->
              <template v-if="['ROOT', 'APPROVAL', 'CC'].includes(item.type)">
                <i v-if="item.type === 'ROOT'" class="el-icon-user-solid icon-timeline" slot="dot"></i>
                <i v-else-if="item.type === 'CC'" class="el-icon-s-promotion icon-timeline" slot="dot"></i>
                <i v-else class="el-icon-s-check icon-timeline" slot="dot"></i>
                <div class="timeline-warp" :data-id="item.id">
                  <div class="timeline-left">
                    <h3 style="margin-bottom: 0">
                      <span v-if="judgeRequired(item)" style="color: red">*</span>
                      {{ item.name }}
                    </h3>
                    <p v-if="item.type === 'ROOT'">发起本流程</p>
                    <p v-else-if="item.type === 'CC'">流程结果将会抄送他们</p>
                    <p v-else>
                      {{ item.props && approvalTypes[item.props.assignedType] }}
                      <span v-if="
                        item.props.assignedUser &&
                        item.props.assignedUser.length > 1
                      ">（{{ item.props.assignedUser.length }}人审批）<a-tag color="purple"
                          v-if="item.props && item.props.mode">{{ countersignModeMap[item.props.mode] }}</a-tag></span>
                      <a-tooltip
                        v-if="item.props.assignedType === 'ROLE' && item.props.role && item.props.role.length > 3"
                        placement="bottom" :title="getFullRoleNames(item.props.role)">
                        <a-tag color="blue" class="role-tag-with-tooltip">{{ formatRoleNames(item.props.role) }}</a-tag>
                      </a-tooltip>
                      <a-tag v-else-if="item.props.assignedType === 'ROLE'" color="blue">{{
                        formatRoleNames(item.props.role) }}</a-tag>
                      <a-tag color="cyan" v-if="item.props.hasCandidate">存在候选人列表
                      </a-tag>
                    </p>
                    <div class="special-info" v-if="showApproverSelect(item)">
                      审批人将由节点【<b>{{
                        approverSelectNodeName(item.props)
                      }}</b>】指派
                    </div>
                  </div>
                  <div class="timeline-right">
                    <!-- 指定人员 -->
                    <template v-if="
                      item.props.assignedUser &&
                      item.props.assignedUser.length &&
                      !['LEADER', 'LEADER_TOP'].includes(
                        item.props.assignedType
                      )
                    ">
                      <div class="avatar-box" v-for="org in item.props.assignedUser" :key="org.id">
                        <div :class="['avatar', org.type]">
                          <i v-if="org.type === 'dept'" class="iconfont icon-map-site"></i>
                          <span v-else>{{ getShortName(org.name) }}</span>
                        </div>
                        <div class="name" :title="org.name">{{ org.name }}</div>
                        <i v-if="showClosePicker(item)" class="close el-icon-close" @click="removeUser(item, org)"></i>
                      </div>
                    </template>
                    <!-- 角色 -->

                    <template v-if="showSelectUser(item)">
                      <div :class="[
                        'avatar-box',
                        showApproverSelect(item, 'root') ? 'disabled' : '',
                      ]">
                        <i class="el-icon-plus add-user" @click="handleAddUser(item)"></i>
                        <span class="name">添加</span>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <!-- 条件分支 -->
              <template v-else>
                <i class="el-icon-share icon-timeline" slot="dot"></i>
                <div class="timeline-warp">
                  <div class="timeline-left">
                    <!-- 分支条件 -->
                    <a-radio-group v-model="selectedCondition" size="small" button-style="solid">
                      <a-radio-button v-for="con in item.branchs" :key="con.id" :value="con.id">
                        <span :class="[
                          'condition',
                          selectedCondition === con.id ? 'active' : '',
                        ]">{{ con.name }}</span>
                      </a-radio-button>
                    </a-radio-group>
                    <p>只执行第一个满足的条件</p>
                  </div>
                </div>
              </template>
            </a-timeline-item>
            <!-- 默认结束节点 -->
            <a-timeline-item>
              <i class="el-icon-success icon-timeline" slot="dot"></i>
              <div style="margin-left: 10px">结束</div>
            </a-timeline-item>
          </a-timeline>
          <a-empty v-else description="暂无审批流程"></a-empty>
        </a-col>
      </a-row>
      <template slot="footer">
        <a-button @click="handleCancel" icon="close">取消</a-button>
        <a-button type="primary" @click="handleOk(0)" :loading="confirmLoading" ghost icon="check-square">暂存</a-button>
        <a-button type="primary" @click="handleOk(1)" :loading="confirmLoading" icon="check">提交</a-button>
      </template>
    </a-modal> 
  </div>
</template>

<script> 
export default {
  components: { 
  },
  data() {
    return {
      modalTitle: '发起审批',
      approvalFormVisible: false,
      confirmLoading: false,
      formData: {},
      // 用于强制重新渲染表单（解决明细表内部状态未重置的问题）
      formRenderKey: 0,
      forms: [],
      process: [], // 审批流程定义
      submitForm: {},
      processId: null,
      selfSelectMultiple: false, // 自选审批人是否多选
      pickerType: 'user', // 用户选择组件类型
      selectedCondition: '', // 选中的条件
      nodePredicParams: {}, // 节点预测条件参数
      formId: null, // 表单id
      originalId: null, // 原始表单id
      draftList: [], // 草稿箱列表
      draftVisible: false,
      formName: '', // 表单名称
      nodepredictDetails: {}, // 节点预测条件详情
      conditionNodeBranchs: [], // 条件节点分支 默认第一个条件分支
      nextApprovalNode: [], // 后续审批节点
      conditionNodeChildren: [], // 条件节点子节点
      selectedUserList: [], // 已选用户
      formTitleRuleConfig: {}, // 表单标题规则配置
      formTitleLoading: false,
      commitFormType: 'initiate',
      showApprovalProcess: true,
      fullProcess: [], // 完整的流程节点
      filterOriginBizAlias: [],
      // 保存组件的原始权限，用于还原
      originalComponentPerms: new Map(), // key: component.id, value: original perm
      // 历史表单相关
      historyFormModalVisible: false,
      historyFormLoading: false,
      historyFormList: [],
      historyFormFilter: {
        formTitle: '',
        keyword: ''
      },
      historyFormPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`
      },
      selectedHistoryFormKeys: [],
      selectedHistoryForm: null,
      // 历史表单表格列定义
      historyFormColumns: [
        {
          title: '工作名称/文号',
          dataIndex: 'formTitle',
          key: 'formTitle',
          scopedSlots: { customRender: 'formTitle' }
        },
        // {
        //   title: "摘要信息",
        //   dataIndex: "summary",
        //   key: "summary",
        //   ellipsis: true,
        // },
        {
          title: 'OA流水号',
          dataIndex: 'serialNumber',
          key: 'serialNumber',
          width: 110
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          key: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 160
        }
      ],
      originalFormComponents: [] // 原始表单组件
    }
  },
  computed: {
    
  },
  methods:{
    opentest(e){
      // console.log("🚀 ~ e:", e)

      this.approvalFormVisible = true
      
    },
    handleCancel() {
      this.approvalFormVisible = false 
    },
  }
    
}
</script>

<style lang="less" scoped>
::v-deep .ant-timeline {
  padding-top: 10px !important;
}

.scrollable-content {
  position: relative;
  min-height: 800px;
  max-height: calc(100vh - 182px);
  overflow-y: auto;

  &::after {
    content: "";
    position: fixed;
    bottom: 53px;
    left: 0;
    width: 100%;
    height: 50px;
    background-image: -webkit-linear-gradient(bottom,
        #f2f5ff 20%,
        rgba(242, 245, 255, 0));
  }
}

.sticky-content {
  position: sticky;
  top: 0;
  max-height: calc(100vh - 182px);
  overflow-y: auto;
}

.icon-timeline {
  font-size: 18px;
  color: #ffffff;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  background: #e4e7ed;
}

.timeline-warp {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;

  .timeline-left {
    &>p {
      margin-bottom: 0;
    }

    .condition {
      text-decoration: line-through;
    }

    .active {
      text-decoration: none;
    }
  }

  .special-info {
    color: #ff7d00;
  }

  .timeline-right {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    max-width: 276px;
  }

  &.shake {
    animation: shake 0.5s;
  }
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  20%,
  60% {
    transform: translateX(-10px);
  }

  40%,
  80% {
    transform: translateX(10px);
  }
}

.avatar-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  &.disabled {
    cursor: not-allowed !important;
    pointer-events: none !important;
    color: rgba(0, 0, 0, 0.25) !important;

    .add-user {
      color: rgba(0, 0, 0, 0.25) !important;
      border: 1px solid #d9d9d9 !important;
      background-color: #f5f5f5 !important;
    }
  }

  .add-user {
    padding: 8px;
    font-size: 18px;
    border-radius: 50%;
    border: 1px dashed #8c8c8c;
    color: #333;
    cursor: pointer;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }

  .name {
    width: 46px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
    color: #fff;
    cursor: pointer;
    border-radius: 50%;
    background: #000;
  }

  .avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 35px;
    height: 35px;
    background: #1890ff;
    color: white;
    border-radius: 50%;

    &.dept {
      background: #f77234;
    }
  }
}

.role-name {
  width: 78px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.modal-title {
  display: flex;
  align-items: center;
  gap: 16px;

  .back-icon {
    cursor: pointer;
    font-size: 14px;
    color: #606266;
  }

  .draft-box {
    margin-left: auto;
    margin-right: 30px;
    color: #f78f5f;
  }
}

.draft-list {
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 16px;

  .draft-list-ul {
    margin: 0;
    padding: 0;
    display: flex;
    gap: 6px;
    flex-direction: column;
    width: 280px;

    .draft-item {
      background: #f5f7fa;
      padding: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .draft-btn {
        &>a:first-child {
          color: red;
        }
      }
    }
  }
}

.work-name {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 8px;

  .work-name-label {
    font-weight: bold;
    font-size: 18px;

    &::before {
      content: "*";
      color: red;
      margin-right: 4px;
    }
  }
}

::v-deep .ant-modal-body {
  padding: 16px 24px !important;
}

/* 角色标签悬停提示样式 */
.role-tag-with-tooltip {
  cursor: help;
  position: relative;
}

.role-tag-with-tooltip:hover {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.form-title {
  width: 100%;
  white-space: normal;
  word-break: break-all; //任意字符间段行：兼容中英数字符号混合换行
  overflow-wrap: break-word;
  line-height: 1.1;
}
</style>
